import fetch from "auth/FetchInterceptor";

const DiscrepancyDeclined = {};

DiscrepancyDeclined.get = function (payload) {
  return fetch({
    url:
      "/reports/discrepancy-declined?" +
      "startdate=" +
      payload.startDate +
      "&enddate=" +
      payload.endDate +
      "&agency=" +
      payload.agency +
      "&department=" +
      payload.department,
    method: "get",
  });
};

DiscrepancyDeclined.update = function (id, data) {
  return fetch({
    url: `/poly-tech-patient-pid/${id}`,
    method: "put",
    data,
  });
};

DiscrepancyDeclined.Discrepancyobx = function (payload) {
  return fetch({
    url: "/reports/discrepancy_obx?" + "sampleId=" + payload.batchUuid + "&batchUuid=" + payload.sampleId,
    method: "get",
  });
};

export default DiscrepancyDeclined;
